import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const OVERNIGHT_AXIS_NOTE =
  "The +1 in the time labels means the chart extends past midnight into the next calendar day. The passengers shown are still part of today’s operations.";

export function showsNextCalendarDay(times: string[]): boolean {
  return times.some((time) => /\s\+\d+$/.test(time));
}

export function OvernightDayNote({ times }: { times: string[] }) {
  if (!showsNextCalendarDay(times)) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="ml-2 inline-flex h-4 w-4 items-center justify-center rounded-full bg-slate-600 text-xs text-white transition-colors hover:bg-indigo-500 focus:outline-none"
            aria-label="What +1 means"
          >
            i
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-sm whitespace-normal leading-relaxed">
          {OVERNIGHT_AXIS_NOTE}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
